import React, { useEffect, useState } from "react";
import { fetchJson } from "../../services/api";
import { OverviewStats } from "../types";
import KPICard from "../components/KPICard";
import { PageHeader, SectionCard, Loader, ErrorMsg, refreshBtnStyle } from "../components/Common";
import "./OverviewPage.css";

const OverviewPage: React.FC = () => {
  const [stats, setStats]     = useState<OverviewStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState<string | null>(null);

  const load = () => {
    setLoading(true);
    fetchJson<OverviewStats>("/monitor/overview/")
      .then(setStats)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading) return <Loader />;
  if (error)   return <ErrorMsg msg={error} onRetry={load} />;
  if (!stats)  return null;

  const changeLabel = stats.change_vs_yesterday_pct >= 0
    ? `+${stats.change_vs_yesterday_pct}% vs yesterday`
    : `${stats.change_vs_yesterday_pct}% vs yesterday`;

  return (
    <div>
      <PageHeader title="Overview" subtitle="Today's API activity at a glance" />
      <div className="overview-page__toolbar">
        <button onClick={load} style={refreshBtnStyle}>↻ Refresh</button>
      </div>

      <div className="overview-page__stats-grid">
        <KPICard label="Total API Calls"   value={stats.total_calls.toLocaleString()}   sub={changeLabel}                                      color="info"    />
        <KPICard label="Success Rate"      value={`${stats.success_rate}%`}             sub={`${stats.success_count.toLocaleString()} successful`} color="success" />
        <KPICard label="Failed Calls"      value={stats.failed_count.toLocaleString()}  sub={`${(100 - stats.success_rate).toFixed(1)}% failure rate`} color="danger"  />
        <KPICard label="Avg Response Time" value={`${stats.avg_response_ms}ms`}         sub={`Peak: ${stats.max_response_ms}ms`}               color="warning" />
      </div>

      <SectionCard title="Today's Summary">
        <table className="overview-page__table">
          <tbody>
            {[
              ["Total Calls",        stats.total_calls.toLocaleString()],
              ["Successful",         stats.success_count.toLocaleString()],
              ["Failed",             stats.failed_count.toLocaleString()],
              ["Success Rate",       `${stats.success_rate}%`],
              ["Avg Response Time",  `${stats.avg_response_ms}ms`],
              ["Peak Response Time", `${stats.max_response_ms}ms`],
              ["Change vs Yesterday", changeLabel],
            ].map(([label, value]) => (
              <tr key={label} className="overview-page__table-row">
                <td className="overview-page__table-label">{label}</td>
                <td className="overview-page__table-value">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </SectionCard>
    </div>
  );
};

export default OverviewPage;
